import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SubHeader from '../../components/SubHeader/SubHeader';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import styles from './WinningsView.module.scss';
import Paragraph from '../../components/Typography/Paragraph/Paragraph';
import Button from '../../components/Button/Button';
import { Routes } from '../../constants/routes';
import Winnings from './Winnings/Winnings';
const WinningsView = () => {
    const { t } = useTranslation();
    const { loggedIn } = useSelector((state) => state.auth);
    return (_jsxs("div", Object.assign({ className: styles.box }, { children: [_jsx(SubHeader, { title: t('winnings'), background: true }), !loggedIn ? (_jsx("div", Object.assign({ className: cn(styles.login, 'd-flex') }, { children: _jsxs("div", { children: [_jsx(Paragraph, { title: t('you_must_be_logged_in'), size: 3, fontFamily: "marope" }), _jsx(Button, { height: 'xs', color: 2, size: 'md', text: t('log_in'), to: Routes.LOGIN, type: 'NavLink' })] }) }))) : (_jsx(Winnings, {}))] })));
};
export default WinningsView;
